module.exports = __webpack_public_path__ + "static/media/boom.85b10077.jpg";